<!--The content below is only a placeholder and can be replaced.-->
<div class="modal fade" id="confirmLogout" tabindex="-1" role="dialog" aria-labelledby="confirmLogoutLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="onfirmLogout">Confirm logout</h5>
        <p-button type="button" styleClass="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </p-button>
      </div>
      <div class="modal-body">Do you wish to logout?</div>
      <div class="modal-footer">
        <p-button type="button" severity="secondary" size="small" data-bs-dismiss="modal" label="Stay logged in"></p-button>
        <p-button type="button " routerLink="/logout" data-bs-dismiss="modal" size="small" severity="danger" label="Logout"></p-button>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <nav class="navbar navbar-expand-lg navbar-fixed-top navbar-dark bg-dark navbar-inverse px-3">
    <a class="navbar-brand" routerLink="/">
      <img class="d-inline-block align-top" style="width: 70px; height: 50px" src="assets/images/logo-brand.png" alt="" />
      {{ config.name }} Account Manager
    </a>
    <p-button styleClass="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </p-button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        @if (isLogged && usages.length > 0) {
          <li class="nav-item dropdown">
            <a href="" id="dropdownMenu0" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="oi oi-bar-chart"></i> Usage</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu0">
              @for (usage of usages; track usage) {
                <li>
                  <a class="dropdown-item" href="{{ usage.link }}" rel="noopener noreferrer" target="_blank">{{ usage.name }}</a>
                </li>
              }
            </ul>
          </li>
        }

        @if (isLogged && config.enable_ui && config.enable_ui.tps) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/tps">
              <i class="glyphicon glyphicon-calendar"></i>
              TP reservations
            </a>
          </li>
        }
        @if (isLogged) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/user/{{ user.uid }}">
              <i class="glyphicon glyphicon-user"></i>
              My profile
            </a>
          </li>
        }
        @if (isLogged) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/project">
              <i class="glyphicon glyphicon-briefcase"></i>
              My projects
            </a>
          </li>
        }
        @if (isLogged && config.enable_ui && config.enable_ui.databases) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/database">
              <i class="glyphicon glyphicon-briefcase"></i>
              My databases
            </a>
          </li>
        }

        @if (user && user.is_admin) {
          <li class="nav-item dropdown">
            <a href="" id="dropdownMenu1" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="glyphicon glyphicon-cog"></i> Admin</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li><a class="dropdown-item" routerLink="/register">New Account</a></li>
              <li><a class="dropdown-item" routerLink="/admin/user">Users</a></li>
              <li><a class="dropdown-item" routerLink="/admin/group">Groups</a></li>
              <li><a class="dropdown-item" routerLink="/admin/project">Projects</a></li>
              @if (config.enable_ui && config.enable_ui.messages) {
                <li><a class="dropdown-item" routerLink="/admin/message">Send message</a></li>
              }
              @if (config.enable_ui && config.enable_ui.databases) {
                <li><a class="dropdown-item" routerLink="/admin/database">Databases</a></li>
              }
              @if (config.enable_ui && config.enable_ui.websites) {
                <li><a class="dropdown-item" routerLink="/admin/web">Web sites</a></li>
              }
              <li><a class="dropdown-item" routerLink="/admin/log">Logs</a></li>
              <li><a class="dropdown-item" routerLink="/admin/stats">Stats</a></li>
              @for (plugin of plugins; track plugin) {
                <li>
                  <a class="dropdown-item" routerLink="/admin/plugin/{{ plugin.name }}">{{ plugin.display_name }}</a>
                </li>
              }
            </ul>
          </li>
        }
        @if (!isLogged) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/login"><span class="oi oi-person" aria-hidden="true" title="login"> </span> Sign In</a>
          </li>
        }
        @if (!isLogged) {
          <li class="nav-item">
            <a class="nav-link" routerLink="/register"><span class="oi oi-plus" aria-hidden="true" title="register"> </span> Sign Up</a>
          </li>
        }
        @if (isLogged) {
          <li class="nav-item">
            <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#confirmLogout">Log Out</a>
          </li>
        }
      </ul>
    </div>
  </nav>
  <div class="col-sm-12">
    <flash-messages></flash-messages>
    <router-outlet></router-outlet>
  </div>
</div>
